import { fetchApi } from '../client';

export type ChronicConditionCode = 'DIABETES' | 'HYPERTENSION';
export type PatientMeasureTier = 'CONFIRMED' | 'SUSPECTED';
export type PatientMeasureStatus = 'TESTED_CONTROLLED' | 'TESTED_UNCONTROLLED' | 'NOT_TESTED';

export interface PatientMeasureRow {
  patientId: string;
  patientName: string;
  tier: PatientMeasureTier;
  lastResultDate?: string;
  lastResultSummary?: string;
  status: PatientMeasureStatus;
}

export interface ConditionMeasure {
  condition: ChronicConditionCode;
  displayName: string;
  confirmedCohortSize: number;
  suspectedCohortSize: number;
  testedCount: number;
  testingRatePct: number;
  controlledCount: number;
  controlRatePct: number;
  measureWindowDays: number;
  clinicalTarget: string;
  patients: PatientMeasureRow[];
}

export interface QualityMeasureResponse {
  clinicId: string;
  measures: ConditionMeasure[];
}

export const chronicDiseaseModule = {
  /** Two-tier (CONFIRMED/SUSPECTED) chronic-disease registries + testing/control quality
   *  measures — diabetes (HbA1c) and hypertension (BP), clinic-wide. Never blocks/writes
   *  anything, read-only analytics. */
  getQualityMeasures: () =>
    fetchApi<QualityMeasureResponse>('/api/analytics/quality-measures'),
};
